import React from 'react';
import styles from '../css/activitiesRptUpdated.module.css';

function ReportsFooter({ page, setPage, pageSize, setPageSize, totalPages, sorted }) {
  const pages = [15, 20, 30, 40, 50];
  return (
    <footer
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 10,
        padding: '12px 24px 16px',
        background: 'white',
        borderRadius: '0 0 12px 12px',
        border: '1.5px solid #e0e7ff',
        borderTop: '1px solid #e0e7ff',
        flexShrink: 0,
      }}
    >
      {/* Left: rows per page */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className={styles.pgLabel} style={{ fontSize: 12, color: '#6b7280' }}>
          Rows per page
        </span>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPage(1);
          }}
        >
          {pages.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>

      {/* Center: page info */}
      <span style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}>
        <span style={{ color: '#4f46e5', fontWeight: 600 }}>
          {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, sorted.length)}
        </span>{' '}
        of {sorted.length}
      </span>

      {/* Right: nav buttons */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {/* First */}
        <button className={styles.pgBtn} onClick={() => setPage(1)} disabled={page === 1} title="First page">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="11 17 6 12 11 7" />
            <line x1="18" y1="7" x2="18" y2="17" />
          </svg>
        </button>

        {/* Previous */}
        <button
          className={styles.pgBtn}
          onClick={() => setPage((p) => p - 1)}
          disabled={page === 1}
          title="Previous"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
          <span className={styles.pgLabel}>Prev</span>
        </button>

        {/* Page numbers */}
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let p;
          if (totalPages <= 5) p = i + 1;
          else if (page <= 3) p = i + 1;
          else if (page >= totalPages - 2) p = totalPages - 4 + i;
          else p = page - 2 + i;
          return (
            <button
              key={p}
              className={`${styles.pgBtn}${p === page ? ' current' : ''}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          );
        })}

        {/* Next */}
        <button
          className={styles.pgBtn}
          onClick={() => setPage((p) => p + 1)}
          disabled={page === totalPages}
          title="Next"
        >
          <span className={styles.pgLabel}>Next</span>
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

        {/* Last */}
        <button
          className={styles.pgBtn}
          onClick={() => setPage(totalPages)}
          disabled={page === totalPages}
          title="Last page"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="13 17 18 12 13 7" />
            <line x1="6" y1="7" x2="6" y2="17" />
          </svg>
        </button>
      </div>
    </footer>
  );
}

export default ReportsFooter;
